import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { styleClasses } from "../../helpers";
import Lottie from "lottie-react";
import { animationSources } from "./sources";
const CSS_PREFIX = `lav-particles-animation`;
export const Animation = (_a) => {
    var { className = "", variant } = _a, lottieProps = __rest(_a, ["className", "variant"]);
    const cName = classNames(styleClasses(CSS_PREFIX, { variant }), {
        [className]: !!className,
    });
    return (_jsx("div", { className: cName, style: lottieProps.style, children: _jsx(Lottie, Object.assign({}, lottieProps, { className: cName, animationData: animationSources[variant] })) }));
};
